<script>
    import Svgo from "./svgo.svelte";
</script>

<Svgo {...$$props} on:click>
    <path
        d="M8.92462 4.57538L16.3492 12L8.92462 19.4246"
        stroke="currentColor"
        stroke-width="1.875"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</Svgo>